import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {
  BalanceItem,
  BokkzJrLogic,
  MonetaryNoDecimalsPeriodValues,
  TrialBalanceItem
} from '@snelstart-ventures/fiscaal/domain-logic';
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiDialogModule} from '@snelstart/ui-dialog';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-trialbalance',
  templateUrl: './spec-trialbalance.component.html',
  imports: [
    SharedUiDialogModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    CommonModule,
  ],
  styleUrls: ['./spec-trialbalance.component.scss']
})
export class SpecTrialbalanceComponent implements OnChanges {

  @Input({ required: true }) public title = {} as string;
  // @Input() public input = this.fb.group<BalanceItem>(({} as BalanceItem));
  @Input({ required: true }) public input!: FormGroup;
  @Input() public dialogVisible = false;
  @Input() public period2Visible = true;
  @Output() public dialogVisibleChange = new EventEmitter<boolean>();
  @Output() public inputChange = new EventEmitter<FormGroup>();
  public inputFg = {} as FormGroup;

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private fb: FormBuilder) {
    this.inputFg = this.fb.group({
      valuePeriod1: null as unknown as number,
      valuePeriod2: null as unknown as number,
      trialBalanceItems: this.fb.array<TrialBalanceItem>([]),
    })
  }

  get trialBalanceItems(): FormArray {
    return this.inputFg.get('trialBalanceItems') as FormArray;
  }

  addRij(): void {
    this.trialBalanceItems.push(this.createFormGroup(), { emitEvent: false });
  }

  verwijderRij(index: number): void {
    this.trialBalanceItems.removeAt(index, { emitEvent: false });
    this.getTotalen();
  }

  createFormGroup(item?: FormGroup): FormGroup {
    const value = item?.getRawValue();

    return this.fb.group(({
      rgsCode: value?.rgsCode ?? null as unknown as string,
      account: value?.account ?? null as unknown as string,
      accountDescription: value?.accountDescription ?? null as unknown as string,
      periodValues: this.fb.group({
        valuePeriod1: value?.periodValues?.valuePeriod1 ?? null as unknown as number,
        valuePeriod2: value?.periodValues?.valuePeriod2 ?? null as unknown as number,
      }),
      autogenerated: value?.autogenerated ?? undefined,
    } as TrialBalanceItem));
  }

  public getTotalen() {
    const items = this.trialBalanceItems;

    if (!items || items.length === 0) {
      this.inputFg.patchValue({
        valuePeriod1: undefined,
        valuePeriod2: undefined
      });

      return;
    }

    let sumPeriod1 = 0;
    let sumPeriod2 = 0;

    let hasValuePeriod1 = false;
    let hasValuePeriod2 = false;

    for (let i = 0; i < items.length; i++) {
      const group = items.at(i) as FormGroup;

      const valuePeriod1 = group.get('periodValues.valuePeriod1')?.value;
      const valuePeriod2 = group.get('periodValues.valuePeriod2')?.value;

      if (valuePeriod1 != null) {
        hasValuePeriod1 = true;
        sumPeriod1 += valuePeriod1;
      }

      if (valuePeriod2 != null) {
        hasValuePeriod2 = true;
        sumPeriod2 += valuePeriod2;
      }
    }

    this.inputFg.patchValue({
      valuePeriod1: hasValuePeriod1 ? sumPeriod1 : undefined,
      valuePeriod2: hasValuePeriod2 ? sumPeriod2 : undefined
    });
  }

  ngOnChanges(): void {
    if (!this.input) return;

    this.syncBalanceItemFormGroups(this.input, this.inputFg)
    this.getTotalen();
  }

  submit() {
    this.syncBalanceItemFormGroups(this.inputFg, this.input)
    this.inputChange.emit(this.input)
    this.dialogVisibleChange.emit(false)
  }

  cancel() {
    this.dialogVisibleChange.emit(false);
  }

  syncBalanceItemFormGroups(sourceFg: FormGroup, targetFg: FormGroup) {
    targetFg.patchValue(sourceFg.getRawValue(), { emitEvent: false });

    const sourceArray = sourceFg.get('trialBalanceItems') as FormArray;
    const targetArray = targetFg.get('trialBalanceItems') as FormArray;

    while (targetArray.length > sourceArray.length) {
      targetArray.removeAt(targetArray.length - 1);
    }
    for (let i = 0; i < sourceArray.length; i++) {
      const sourceGroup = sourceArray.at(i) as FormGroup;

      if (i < targetArray.length) {
        const targetGroup  = targetArray.at(i) as FormGroup;
        targetGroup.patchValue(sourceGroup.getRawValue(), { emitEvent: false });
      } else {
        const formGroup = this.createFormGroup(sourceGroup)
        targetArray.push(formGroup);
      }
    }
  }
}
